module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/online-vault-4.810ab926.svg";